import Api from "@/service/api.js";
// import axios from "axios";

export default {
  state: () => ({
    nftImg: require("@/assets/images/icon/nft.svg"),
    nftInfo: {},
    nftTokenId: "",
    levelRulesListData: [
      {
        nfts: require("@/assets/images/rewards/LV1@3x.png"),
        level: "LV 1",
        transactionFee: "0.038%",
        commissionReferral: "5%",
        commissionRebate: "5%",
        rewardCoefficient: "0",
        tradingUSDTLadder: "0",
        stakingFXLadder: "0 $FX",
      },
      {
        nfts: require("@/assets/images/rewards/LV2@3x.png"),
        level: "LV 2",
        transactionFee: "0.036%",
        commissionReferral: "20%",
        commissionRebate: "10%",
        rewardCoefficient: "0.5",
        tradingUSDTLadder: "500000",
        stakingFXLadder: "0 $FX",
      },
      {
        nfts: require("@/assets/images/icon/nft.svg"),
        level: "LV 3",
        transactionFee: "0.034%",
        commissionReferral: "25%",
        commissionRebate: "15%",
        rewardCoefficient: "1",
        tradingUSDTLadder: "1000000",
        stakingFXLadder: "10,000 $FX",
      },
      {
        nfts: require("@/assets/images/icon/nft.svg"),
        level: "LV 4",
        transactionFee: "0.032%",
        commissionReferral: "40%",
        commissionRebate: "20%",
        rewardCoefficient: "7",
        tradingUSDTLadder: "5000000",
        stakingFXLadder: "60,000 $FX",
      },
      {
        nfts: require("@/assets/images/icon/nft.svg"),
        level: "LV 5",
        transactionFee: "0.030%",
        commissionReferral: "40%",
        commissionRebate: "25%",
        rewardCoefficient: "30",
        tradingUSDTLadder: "20000000",
        stakingFXLadder: "250,000 $FX",
      },
      {
        nfts: require("@/assets/images/icon/nft.svg"),
        level: "LV 6",
        transactionFee: "0.028%",
        commissionReferral: "50%",
        commissionRebate: "30%",
        rewardCoefficient: "100",
        tradingUSDTLadder: "80000000",
        stakingFXLadder: "800,000 $FX",
      },
    ],
  }),
  mutations: {
    SET_NFT_TOKEN_ID(state, data) {
      state.nftTokenId = data;
    },
    SET_NFT_INFP(state, data) {
      state.nftInfo = data;
    },
    SET_NFT_IMG(state, data) {
      state.nftImg = data;
    },
  },
  actions: {
    async getHighLevelNftDetail({ commit }, address) {
      const highLevelNftDetail = await Api["highLevelNftDetail"]({
        address: address,
      });

      // if (highLevelNftDetail.tokenId) {
      //   commit("SET_NFT_TOKEN_ID", highLevelNftDetail.tokenId);

      //   commit("SET_NFT_IMG", highLevelNftDetail.file);

      //   commit("SET_NFT_INFP", JSON.parse(highLevelNftDetail.jsonDetail));
      // } else {
      //   commit("SET_NFT_IMG", require("@/assets/images/icon/nft.svg"));
      //   commit("SET_NFT_INFP", {});
      //   commit("SET_NFT_TOKEN_ID", "");
      // }
    },
  },
  getters: {
    getTradingUSDTLadder: (state) => {
      if (Number(state.nftTokenId) > 6 || Number(state.nftTokenId) <= 0)
        return "0";
      const tradingUSDTLadder =
        state.levelRulesListData[Number(state.nftTokenId)];

      return tradingUSDTLadder ? tradingUSDTLadder.tradingUSDTLadder : "0";
    },
    getNftTransactionFee: (state) => {
      if (state.nftInfo.attributes) {
        return state.nftInfo.attributes.find((elem) => {
          return elem.trait_type === "Fee";
        });
      } else {
        return {
          trait_type: "Fee",
          value: "0.04%",
        };
      }
    },
    getNftCommissionRebate: (state) => {
      if (state.nftInfo.attributes) {
        return state.nftInfo.attributes.find((elem) => {
          return elem.trait_type === "Rebate";
        });
      } else {
        return {
          trait_type: "Rebate",
          value: "5%",
        };
      }
    },
    getNftCommissionReferral: (state) => {
      if (state.nftInfo.attributes) {
        return state.nftInfo.attributes.find((elem) => {
          return elem.trait_type === "Referral";
        });
      } else {
        return {
          trait_type: "Referral",
          value: "0%",
        };
      }
    },
    getNftRewardCoefficient: (state) => {
      if (state.nftInfo.attributes) {
        return state.nftInfo.attributes.find((elem) => {
          return elem.trait_type === "Share";
        });
      } else {
        return {
          trait_type: "Share",
          value: "0",
        };
      }
    },
  },
};
